import { PackagingRulesets } from '@modules/Packaging/packagingRulesets';
import { useParams } from 'react-router-dom';

/**
 * Ruta `/clients/:clientId/packaging-rulesets`: vista de reglas con `team_id` del cliente (3PL).
 */
export const ClientPackagingRulesets = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const teamId = clientId ? parseInt(clientId, 10) : NaN;
  if (!Number.isFinite(teamId)) {
    return null;
  }
  return <PackagingRulesets scopedTeamId={teamId} />;
};
